export enum OrderStatus {
  OPEN = "open",
  APPROVED = "approved",
  WAITING = "waiting",
  WAITING_APPROVAL = "waiting_approval",
  CANCELED = "canceled",
  APPROVING = "approving",
  ON_APPROVAL = "on_approval",
  CHANGING = "changing",
  REJECTED = "rejected",
  CANCELING = "canceling",
  QUOTING = "quoting",
  FAILED = "failed",
  EXPIRED = "expired",
  QUOTED = "quoted",
  EXPIRED_TIME = "expired_time",
  PENDING_ISSUE = "pending_issue",
  ISSUED = "issued",
  WAITING_PAYMENT = "waiting_payment",
  WAITING_FINANCIAL_APPROVAL = "waiting_financial_approval",
  FINISHED = "finished",
  ALL = "all",
}
